import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FacultyMedicalProcedureModel } from "../../model/faculty_medical_procedure.model";
import { FacultyMedicalProcedureCaseReviewParameterModel } from "../../model/faculty_medical_procedure_case_review.model";
import { FacultyMedicalProcedureCaseReviewParameterService } from "../../providers/faculty_medical_procedure_case_review_parameter.service";
import { AddSuccessSnackbarComponent } from "../add-success-snackbar/add-success-snackbar.component";

@Component({
  selector: "app-procedure-review-parameter-add-dialog",
  templateUrl: "./procedure-review-parameter-add-dialog.component.html",
  styleUrls: ["./procedure-review-parameter-add-dialog.component.css"],
})
export class ProcedureReviewParameterAddDialogComponent implements OnInit {
  newItem:FacultyMedicalProcedureCaseReviewParameterModel;
  mFacultyMedicalProcedure: FacultyMedicalProcedureModel;
  errorMessage: string = "";
  isLoading: boolean = true;
  durationInSeconds = 1;
  mItems:FacultyMedicalProcedureCaseReviewParameterModel[]; 

  
  constructor(private fb: FormBuilder, private mApiService:FacultyMedicalProcedureCaseReviewParameterService,private _snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<ProcedureReviewParameterAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any) {}

  ngOnInit(): void {
    this.newItem = new FacultyMedicalProcedureCaseReviewParameterModel();
  }


  getItemsList(id:string)
{
     this.mItems=[];
     this.isLoading=true;
     

         this.mApiService.getItems(id)
         .subscribe(
           p=>{
             
            this.mItems=p
            
           },
           e => this.errorMessage = e,
           ()=>this.isLoading=false
         )

    
}

  saveNewItem(){

    this.newItem.FacultyMedicalProcedureId=this.mFacultyMedicalProcedure.Id;
    
     this.mApiService
     .addItem(this.newItem)
     .subscribe(
      p=>{

        this.dialogRef.close() ;

        this._snackBar.openFromComponent(AddSuccessSnackbarComponent, {
          duration: this.durationInSeconds * 1000,
        });
           
            //  this.varShowAddDialog=false;
             this.newItem=new FacultyMedicalProcedureCaseReviewParameterModel();
             this.getItemsList(   this.mFacultyMedicalProcedure.Id)
         
        
        },
      e => this.errorMessage = e,
      ()=>this.isLoading=false
    )

}
}
